"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroupExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/button-group/examples/index.ts';
var ButtonGroupExample = /** @class */ (function () {
    function ButtonGroupExample() {
        this.fluid = false;
        this.label = true;
        this.rounded = false;
        this.outlined = false;
        this.basic = false;
    }
    ButtonGroupExample.prototype.view = function () {
        var attrs = {
            size: this.size,
            intent: this.intent,
            rounded: this.rounded,
            basic: this.basic,
            fluid: this.fluid,
            outlined: this.outlined
        };
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.ButtonGroup, tslib_1.__assign({}, attrs), [
                (0, mithril_1.default)(_1.Button, {
                    iconLeft: _1.Icons.COPY,
                    label: this.label && 'Copy'
                }),
                (0, mithril_1.default)(_1.Button, {
                    iconLeft: _1.Icons.SETTINGS,
                    label: this.label && 'Settings'
                }),
                (0, mithril_1.default)(_1.Button, {
                    iconLeft: _1.Icons.LINK,
                    iconRight: _1.Icons.CHEVRON_DOWN,
                    label: this.label && 'Link'
                })
            ])
        ]);
    };
    ButtonGroupExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.label,
                label: 'Label',
                onchange: function () { return _this.label = !_this.label; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.rounded,
                label: 'Rounded',
                onchange: function () { return _this.rounded = !_this.rounded; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.basic,
                label: 'Basic',
                onchange: function () {
                    _this.basic = !_this.basic;
                    _this.outlined = false;
                }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.outlined,
                label: 'Outlined',
                onchange: function () {
                    _this.outlined = !_this.outlined;
                    _this.basic = false;
                }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.fluid,
                label: 'Fluid',
                onchange: function () { return _this.fluid = !_this.fluid; }
            })
        ];
    };
    return ButtonGroupExample;
}());
exports.ButtonGroupExample = ButtonGroupExample;
